import ApiBase from 'ApiRest/ApiBase'

export const ApiCoursesCategories = new (class extends ApiBase {
  get() {
    const url = `/courses/categories`

    return this._GET(url)
  }
})()
